<ng-template #titleTpl>
  <intelishs-page-header title="Cambiar Área" [subtitle]="subtitulo()" />
</ng-template>

<nz-modal
  [nzVisible]="visible()"
  [nzTitle]="titleTpl"
  [nzFooter]="modalFooter"
  (nzOnCancel)="cerrar()"
>
  <ng-template nzModalContent>
    @if (empleado(); as emp) {
      <!-- La asignación vigente, congelada al abrir: los tres selects vienen
           preseleccionados con ella, así que en cuanto el usuario cambia uno
           este panel es el único lugar donde queda el punto de partida. Antes
           eran dos filas etiqueta/valor que repetían lo que el dropdown de
           abajo ya mostraba, y el director —que también se cambia aquí— no
           aparecía por ningún lado. -->
      <div class="seccion-panel asignacion">
        <span class="asignacion__titulo">Asignación actual</span>
        <p class="asignacion__valor">{{ describirAdscripcion(emp) }}</p>
        <p class="asignacion__meta">
          @if (directorOriginal()) {
            Reporta a {{ directorOriginal() }}
          } @else {
            Sin director asignado
          }
        </p>
      </div>

      <div class="sinay-select-floating campo campo--primero">
        <nz-select
          nzId="dirSel"
          [ngModel]="direccionIdSel()"
          (ngModelChange)="direccionIdSel.set($event)"
          nzShowSearch
          [nzLoading]="loadingCats()"
        >
          @for (d of direcciones(); track d.id) {
            <nz-option [nzValue]="d.id" [nzLabel]="d.descripcion" />
          }
        </nz-select>
        <label class="sinay-float-label" for="dirSel">Nueva Dirección</label>
      </div>

      <div class="sinay-select-floating campo">
        <nz-select
          nzId="areaSel"
          [ngModel]="areaIdSel()"
          (ngModelChange)="areaIdSel.set($event)"
          nzShowSearch
          [nzLoading]="loadingCats()"
        >
          @for (a of areas(); track a.id) {
            <nz-option [nzValue]="a.id" [nzLabel]="a.descripcion" />
          }
        </nz-select>
        <label class="sinay-float-label" for="areaSel">Nueva Área</label>
      </div>

      <div class="sinay-select-floating campo">
        <nz-select
          nzId="dirSelSup"
          [ngModel]="directorIdSel()"
          (ngModelChange)="directorIdSel.set($event)"
          nzShowSearch
          [nzLoading]="loadingCats()"
        >
          @for (d of directores(); track d.directorId) {
            <nz-option
              [nzValue]="d.directorId"
              [nzLabel]="d.directorNombre + ' (' + d.directorIdInterno + ')'"
            />
          }
        </nz-select>
        <label class="sinay-float-label" for="dirSelSup">Nuevo Director</label>
      </div>
    }
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button class="sinay-outline-reset" (click)="cerrar()">Cancelar</button>
    <!-- Deshabilitado mientras la selección sea la que ya estaba: guardar sin
         cambios dispara un DELETE+INSERT en `relempleadodireccionarea` que no
         cambia nada, y deja al usuario sin saber si su cambio se aplicó. -->
    <button
      nz-button
      class="btn-add"
      [nzLoading]="guardando()"
      [disabled]="loadingCats() || !seleccionCompleta() || !hayCambios()"
      (click)="guardar()"
    >
      Guardar
    </button>
  </ng-template>
</nz-modal>
